import * as React from 'react';
import { connect } from 'react-redux';

import Sidenote from 'components/sidenote/Sidenote';

import BaseSubcampaignPage from '../BaseSubcampaignPage';
import CampaignSummaryShort from 'modules/campaigns/components/campaign-summary/campaign-summary-short/CampaignSummaryShort';
import SubcampaignPayments from 'modules/subcampaigns/components/SubcampaignPayments';

import { COUNTRY_ITALY, getPaymentDetailsExplanationType } from 'utils/organization';
import { __t, applyTranslations } from 'utils/language';

import './subcampaign-payments-page.scss';

applyTranslations(require('./subcampaign-payments-page.i18n.json'));

import type { BrandProfile, Campaign, Subcampaign } from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  params: {
    id: string,
    subcampaignId: string
  }
};

type StateProps = {
  subcampaign: Subcampaign | undefined | null,
  campaign: Campaign | undefined | null,
  brandProfile: BrandProfile | undefined | null,
  country: string
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // it is added by connect, so we need to keep it here
} & OwnProps & StateProps;

const MSG_KEY = 'subcampaign_payments_page';

const SubcampaignPaymentsPage = (
  {
    subcampaign,
    campaign,
    brandProfile,
    params,
    country
  }: Props
): JSX.Element => (
  <BaseSubcampaignPage
    params={params}
    documentTitle={__t(`${MSG_KEY}.title`)}
  >
    {getPaymentDetailsExplanationType(country) === COUNTRY_ITALY && (
      <Sidenote
        withCenteredIcon
        type="info"
        layout="horizontal"
        className="subcampaign-payments-page__sidenote"
        message={__t(`${MSG_KEY}.italy_invoice_reminder`)}
      />
    )}
    {subcampaign?.id && campaign?.id && (
      <React.Fragment>
        <CampaignSummaryShort
          brandProfile={brandProfile}
          campaign={campaign}
          subcampaign={subcampaign}
          profileType="influencer"
        />
        <SubcampaignPayments />
      </React.Fragment>
    )}
  </BaseSubcampaignPage>
);

const mapStateToProps = ({ subcampaign, campaignBrief, brandProfile, organizationSettings }): StateProps => ({
  subcampaign: subcampaign.data,
  campaign: campaignBrief.brief,
  brandProfile: brandProfile.profile,
  country: organizationSettings.organization.billingAddress?.country
});

export default connect(mapStateToProps)(SubcampaignPaymentsPage);
